import { Navigate, useParams } from "react-router-dom";
import { TopBar } from "../../../../widgets";
import dayjs from "dayjs";
import { BottomSheet } from "../../../../shared";
import { useLayoutEffect, useState } from "react";
import { Flex, Input } from "antd";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch, useSelector } from "react-redux";
import { getProgramBookingAsync } from "../../../../modules/programBooking";
import { RootState } from "../../../../modules";
import BookingSecondStepFooter from "./footer";
import { ReactComponent as ArrowDown } from "../../../../assets/images/icon/arrow-down.svg"
import { ConfirmBottomSheet } from "./confirmBottomSheet";
import { useGetProgramById } from "../firstStep/model";
import { ReactComponent as Close } from '../../../../assets/images/icon/close.svg';
import { ReactComponent as CircleCheck } from "../../../../assets/images/icon/circle-check.svg";
import './index.css'

const WellnessProgramBookSecondStep = () => {
    const id = Number(useParams().id);
    const dispatch: ThunkDispatch<any, any, any> = useDispatch();
    const update = getProgramBookingAsync;
    const { form, ticketList } = useSelector((state: RootState) => state.programBooking);
    const [isShowBottomSheet, setIsShowBottomSheet] = useState<boolean>(false);
    const [isShowConfirmButtomSheet, setIsShowConfirmButtomSheet] = useState<boolean>(false);
    const [bottomSheetDataList, setBottomSheetDataList] = useState<Array<IBottomSheet>>([]);
    const [selectedOptionType, setSelectedOptionType] = useState<string>('')
    const { data, isPending } = useGetProgramById(id, 'isPaid programSelectOptionList { id idx name description isRequired } programSelectOptionItemList { id name programSelectOptionId } programSubjectOptionList { id idx name description isRequired }')
    const updateForm = (key: string, value?: number | string) => {
        const updatedCount = { ...form };
        if (value === undefined) {
            delete updatedCount[key];
        } else {
            updatedCount[key] = value;
        }
        dispatch(update({
            form: updatedCount,
            ticketList: ticketList
        }));
    }
    const getTotalBookingCnt = () => {
        return ticketList.reduce((sum, ticket) => sum + ticket.count, 0);
    }
    const getTotalBookingPrice = () => {
        return ticketList.reduce((sum, ticket) => sum + (ticket.payAmount * ticket.count), 0);
    }
    const getBookingData = (): IBookingData => {
        const returnValue = {
            programId: id,
            title: form[`title`]?.toString(),
            imageUrl: form[`imageUrl`]?.toString(),
            locationName: form[`locationName`]?.toString(),
            date: form[`date`]?.toString(),
            startTime: form[`startTime`]?.toString(),
            totalBookingCtn: getTotalBookingCnt(),
            totalPrice: Number(form['totalPrice']),
            eventId: Number(form['eventId']),
            optionList: {
                selectOptionList: data?.programSelectOptionList
                    ? data.programSelectOptionList
                        .filter(selecteOption => Object.keys(form).some(key => key.includes(`programSelectOption-${selecteOption.id}`)))
                        .map(selecteOption => ({
                            id: String(selecteOption.id),
                            idx: selecteOption.idx ?? 0,
                            name: selecteOption.name,
                            description: selecteOption.description,
                            isRequired: selecteOption.isRequired,
                            selectedOptionId: form[`programSelectOption-${selecteOption.id}`]?.toString(),
                            selectedOptionName: data.programSelectOptionItemList.find(item => item.id === form[`programSelectOption-${selecteOption.id}`])?.name ?? ''
                        }))
                    : [],
                subjectOptionList: data?.programSubjectOptionList
                    ? data.programSubjectOptionList
                        .filter(subjectOption => Object.keys(form).some(key => key.includes(`programSubjectOption-${subjectOption.id}`)))
                        .map(subjectOption => ({
                            id: String(subjectOption.id),
                            idx: subjectOption.idx ?? 0,
                            name: subjectOption.name,
                            description: subjectOption.description,
                            isRequired: subjectOption.isRequired,
                            value: form[`programSubjectOption-${subjectOption.id}`]?.toString()
                        }))
                    : []
            },
            ticketList: ticketList
        }
        return returnValue
    }
    const checkIsRequiredInput = () => {
        if (!data) return
        const isSelectRequired = data.programSelectOptionList.every(selectedOption => selectedOption.isRequired ? form[`programSelectOption-${selectedOption.id}`] : true)
        const isSubjectRequired = data.programSubjectOptionList.every(subjectOption => subjectOption.isRequired ? form[`programSubjectOption-${subjectOption.id}`] : true)
        return isSelectRequired && isSubjectRequired
    }

    useLayoutEffect(() => {
        const filteredForm = Object.fromEntries(Object.entries(form).filter(([key]) => !key.startsWith('programS')));
        dispatch(update({ form: filteredForm, ticketList: ticketList }));
    }, []);


    if (isNaN(id)) return <Navigate to={'/explore'} />
    if (!form.date) return <Navigate to={`/wellness-program/book/first-step/${id}`} />

    return <>
        <TopBar title="예약" rightIcon={false} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '40px', paddingTop: 24 }}>
            {(data?.programSelectOptionList.length ?? 0) > 0 &&
                <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                    {data?.programSelectOptionList?.map(selecteOption =>
                        <div key={selecteOption.id} style={{ paddingInline: '20px' }}>
                            <div style={{ display: 'flex', marginBottom: 2 }}>
                                <div className="sub-title/st3">
                                    {selecteOption.name}
                                </div>
                                {selecteOption.isRequired && <div className="caption/c1 error/e400">*</div>}
                            </div>
                            <div className="body/b2 secondary/s500">
                                {selecteOption.description}
                            </div>
                            <div
                                onClick={() => {
                                    setSelectedOptionType(`programSelectOption-${selecteOption.id}`)
                                    const targetOptionItemList = data.programSelectOptionItemList.filter(item => Number(item.programSelectOptionId) === Number(selecteOption.id))
                                    if (!selecteOption.isRequired) {
                                        targetOptionItemList.unshift({ id: 0, name: '선택안함', programSelectOptionId: 0 })
                                    }
                                    setBottomSheetDataList(targetOptionItemList.map((item) => ({ id: item.id, label: item.name, value: item.id })))
                                    setIsShowBottomSheet(true)
                                }}
                                style={{ border: '1px solid var(--secondarys300)', borderRadius: 'var(--radius4)', marginTop: 20, cursor: 'pointer' }}
                            >
                                <Flex style={{ minHeight: 17, padding: '12px 16px', alignItems: 'center' }}>
                                    <div className="sub-title/st2 secondary/s600" style={{ flex: 1 }}>{data.programSelectOptionItemList.find((item: any) => item.id === form[`programSelectOption-${selecteOption.id}`])?.name ?? <span className="secondary/s400">{selecteOption.isRequired ? '선택' : '선택안함'}</span>}</div>
                                    <ArrowDown width={16} height={16} stroke={"#AEAEAE"} style={{ marginLeft: '16px' }} />
                                </Flex>
                            </div>
                        </div>)}
                </div>}
            {(data?.programSubjectOptionList.length ?? 0) > 0 &&
                <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                    {data?.programSubjectOptionList?.map((subjectOption: any) =>
                        <div key={subjectOption.id} style={{ paddingInline: '20px' }} className="program-subject-container">
                            <div style={{ display: 'flex', marginBottom: 2 }}>
                                <div className="sub-title/st3">
                                    {subjectOption.name}
                                </div>
                                {subjectOption.isRequired && <div className="caption/c1 error/e400">*</div>}
                            </div>
                            <div className="body/b2 secondary/s500" >
                                {subjectOption.description}
                            </div>
                            <Input
                                classNames={{ input: 'body/b2' }}
                                style={{ borderRadius: 'var(--radius4)', marginTop: 20, borderColor: 'var(--secondarys300)' }}
                                size="large"
                                onChange={(q) => updateForm(`programSubjectOption-${subjectOption.id}`, q.target.value === '' ? undefined : q.target.value)}
                                placeholder={'내용을 적어주세요.'} />
                        </div>)}
                </div>}
        </div>
        {data?.isPaid
            ? <BookingSecondStepFooter
                text="다음"
                date={!form.date ? undefined : `${dayjs(form.date?.toString()).format("YYYY.MM.DD (ddd)")}  ${form.startTime ?? ''}`}
                totalBookingPrice={getTotalBookingPrice()}
                disabled={(getTotalBookingPrice() === undefined || getTotalBookingPrice() === 0) || !form.date || !form["eventId"] || !checkIsRequiredInput()}
                onClickBookingBtn={() => setIsShowConfirmButtomSheet(true)} />
            : <BookingSecondStepFooter
                text="다음"
                date={!form.date ? undefined : `${dayjs(form.date?.toString()).format("YYYY.MM.DD (ddd)")}  ${form.startTime ?? ''}`}
                totalBookingCnt={getTotalBookingCnt()}
                disabled={(getTotalBookingCnt() === undefined || getTotalBookingCnt() === 0) || !form.date || !form["eventId"] || !checkIsRequiredInput()}
                onClickBookingBtn={() => setIsShowConfirmButtomSheet(true)} />}


        <BottomSheet
            header={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '20px' }}>
                <div className="title/t1 base/black">
                    선택
                </div>
                <Close width={16} height={16} stroke="#AEAEAE" style={{ padding: 'var(--space8)', cursor: 'pointer' }} onClick={() => setIsShowBottomSheet(false)} />
            </div>}
            onCustomContentNode={(data, value) => <>
                <div className={data.value === value ? 'title/t1' : 'body/b3'} style={{ paddingBlock: data.value === value ? '6.5px' : '' }}>
                    {data.label}
                </div>
                {data.value === value && <CircleCheck width={20} height={20} stroke={"#FFFFFF"} fill={"#000000"} style={{ padding: 6, marginLeft: '16px' }} />}
            </>}
            customContentHeight={61}
            isOpen={isShowBottomSheet}
            setIsOpen={setIsShowBottomSheet}
            dataList={bottomSheetDataList}
            value={form[selectedOptionType]}
            setValue={value => {
                setIsShowBottomSheet(false);
                Number(value) === 0 ? updateForm(selectedOptionType, undefined) : updateForm(selectedOptionType, value);
            }}
            isShowLabel={false}
            styles={{ modalContent: { padding: '20px 20px 40px 20px', borderRadius: '16px 16px 0 0' }, data: { padding: '8px 0' } }}
        />

        {isShowConfirmButtomSheet &&
            <ConfirmBottomSheet
                isOpen={isShowConfirmButtomSheet}
                setIsOpen={setIsShowConfirmButtomSheet}
                bookingData={getBookingData()}
                isPaid={data?.isPaid === true}
            />}
    </>
}

export { WellnessProgramBookSecondStep }